export default "__VITE_ASSET__CbD3cHx8__"